import { Event, EventIndex, EventType } from '@/models'
import { BaseService, type IAuthService } from '@/services'
import { APIEndpoints, APIScopes, APIURL } from '@/services/API'
export interface IEventID {
	EventID: string
}
export class EventService extends BaseService {
	constructor(authService: IAuthService) {
		super(APIURL, authService, APIScopes)
	}
	async getIndex(params?: object): Promise<EventIndex[]> {
		return this.getData<EventIndex[]>(`${APIEndpoints.event}/`, params)
			.then((data) => {
				// Handle "No results Found" response from API
				if (data && typeof data === 'object' && !Array.isArray(data) && 'Message' in data) {
					return []
				}
				return data.map((c: EventIndex) => new EventIndex(c))
			})
			.catch((err) => {
				throw err
			})
	}
	async get(id: string): Promise<Event> {
		return this.getData<Event>(`${APIEndpoints.event}/${id}`)
			.then((data) => {
				return new Event(data)
			})
			.catch((err) => {
				throw err
			})
	}
	async getCode(name: string, date: Date): Promise<string> {
		const params = new URLSearchParams([
			['name', name],
			['eventDate', new Date(date).toISOString().split('T')[0]]
		])
		// params.append('name', name)
		// params.append('eventDate', date.toISOString())

		return this.getData<string>(`${APIEndpoints.event}/code`, params)
			.then((data) => {
				return data
			})
			.catch((err) => {
				throw err
			})
	}
	async add(event: Event): Promise<Event> {
		const obj = event.toJSON()
		return this.postData<string, Event>(`${APIEndpoints.event}/add`, obj)
			.then((res) => {
				return res as Event
			})
			.catch((err) => {
				throw err
			})
	}
	async update(event: Event): Promise<Event> {
		const obj = event.toJSON()
		return this.patchData<string, Event>(`${APIEndpoints.event}/update`, obj)
			.then((data) => {
				return new Event(data)
			})
			.catch((err) => {
				throw err
			})
	}
	async getTypes(): Promise<EventType[]> {
		return this.getData<EventType[]>(`${APIEndpoints.eventType}`)
			.then((data) => {
				// Handle "No results Found" response from API
				if (data && typeof data === 'object' && !Array.isArray(data) && 'Message' in data) {
					return []
				}
				return data.map((c) => new EventType(c))
			})
			.catch((err) => {
				throw err
			})
	}
	async addTypes(eventType: EventType): Promise<EventType> {
		const obj = eventType
		return this.postData<EventType, EventType>(`${APIEndpoints.eventType}/add`, obj)
			.then((data) => {
				return new EventType(data)
			})
			.catch((err) => {
				throw err
			})
	}
}
